import { Component } from '@angular/core';

@Component({
  selector: 'app-no-valid-price',
  imports: [],
  templateUrl: './no-valid-price.component.html',
  styleUrl: './no-valid-price.component.scss'
})
export class NoValidPriceComponent {

}
